import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {
	const carousels = document.querySelectorAll('.carousel');

	carousels.forEach((carousel) => {

		const perPageDesktop = parseInt(carousel.dataset.perPageDesktop) || 9;
		const perPageTablet = parseInt(carousel.dataset.perPageTablet) || 6;
		const perPageMobile = parseInt(carousel.dataset.perPageMobile) || 2;
		const pagination =
		carousel.dataset.pagination === undefined
			? true
			: carousel.dataset.pagination === 'true';

		const arrow =
		carousel.dataset.arrow === undefined
			? true
			: carousel.dataset.arrow === 'true';


		new Splide(carousel, {
			type: 'loop',
			perPage: perPageDesktop,
			gap: '24px',
			arrows: arrow,
			drag: true,
			keyboard: 'global',
			pagination: pagination,
			breakpoints: {
				1024: { perPage: perPageTablet },
				768: { perPage: perPageMobile }
			}
		}).mount();
	});
});
